import Breakfast from "../components/Breakfast";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Home() {
    return (
        <>
            <Navbar />
            <Hero
                cName="hero"
                heroImg="https://cdn.pixabay.com/photo/2018/05/29/21/50/granola-3440204_640.jpg"
                title="15 - Minute Recipes  "
                text="Start a day with a healthy meal"
                para="Start your day with one of these flavorful breakfast recipes. These recipes take just 15 minutes to prepare, so you can be ready and out the door in no time. We know you'll love these delicious recipes. Recipes like our Besan Chilla and Mango-Almond Smoothie Bowl are breakfasts you'll want to make on repeat."
            />
            <Breakfast/>
            <Footer/>
        </>
    )
}